import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField  from "../../../../../../../../ui/TextField";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles({
  root: {
    maxWidth: 774,
    minWidth: 400,
    marginLeft: 8,
    marginRight: 8,
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  });

const SkillViewWorkplace = ({safety, safetyFirst}) => {
  const classes = useStyles();

  return (
      <div  className={classes.root}>
      <Typography className={classes.heading}>Требования к организации рабочего места и технике безопасности</Typography>

      <TextField
        value={safety}
        label="Общие требования безопасности"
        readOnly
        multiline
      />

      <TextField
        value={safetyFirst}
        label="Требования безопасности перед началом работы"
        readOnly
        multiline
      />
    </div>
  );
};

export default SkillViewWorkplace;
